import { signOut as apiSignOut } from "@/client";

export { getCookie } from "./cookies";

declare const pageVars: { isSignedIn?: boolean } | undefined;

/**
 * Whether the page was rendered for a signed-in visitor. False for a creator
 * previewing their AskPage as a guest.
 */
export function isSignedIn(): boolean {
	return typeof pageVars !== "undefined" && pageVars?.isSignedIn === true;
}

/**
 * Sign-in URL that brings the visitor back to where they are now (or to
 * `returnTo`) once they have signed in. The server validates the parameter and
 * ignores anything that isn't a path on this host.
 */
export function signInUrl(returnTo?: string): string {
	const target =
		returnTo ?? `${window.location.pathname}${window.location.search}`;

	return `/sign-in?redirect=${encodeURIComponent(target)}`;
}

export async function signOut() {
	await apiSignOut();
	window.location.href = "/sign-in";
}
